import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Extract everything after the language segment so language switches don't count as new pages.
function stripLang(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return "";
  if (parts[0] === "hr" || parts[0] === "en") {
    return "/" + parts.slice(1).join("/");
  }
  return pathname;
}

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevRef = useRef(stripLang(pathname));

  useEffect(() => {
    const current = stripLang(pathname);
    if (current !== prevRef.current) {
      // Route changed (not just language), scroll to top
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
      prevRef.current = current;
    } else {
      // Same route, different language - restore scroll position if saved
      try {
        const savedScroll = window.sessionStorage.getItem("zyravex_scroll_restore");
        if (savedScroll !== null) {
          const scrollY = parseInt(savedScroll, 10);
          window.sessionStorage.removeItem("zyravex_scroll_restore");
          // Use requestAnimationFrame to ensure DOM is fully rendered before scrolling
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.scrollTo({ top: scrollY, left: 0, behavior: "instant" in window ? "instant" : "auto" });
            });
          });
        }
      } catch (_) {}
    }
  }, [pathname]);

  return null;
}
